/** Etiquetas y ids de estatus por filtro de "Mis Cursos". */
import {
  COURSE_STATUS_APPROVED,
  COURSE_STATUS_PENDING,
  COURSE_STATUS_REJECTED,
  COURSE_STATUS_APPROVED_NAME,
  COURSE_STATUS_PENDING_NAME,
  COURSE_STATUS_REJECTED_NAME,
} from 'Constants/General';
import type { MyCourseStatusFilterT } from 'types';

export const STATUS_BY_FILTER: Record<MyCourseStatusFilterT, { id: string; name: string }> = {
  pending: { id: COURSE_STATUS_PENDING, name: COURSE_STATUS_PENDING_NAME },
  approved: { id: COURSE_STATUS_APPROVED, name: COURSE_STATUS_APPROVED_NAME },
  failed: { id: COURSE_STATUS_REJECTED, name: COURSE_STATUS_REJECTED_NAME },
  // Un curso opcional sin inscripción no tiene estatus real todavía: comparte
  // el id de "Por Cursar" para tratarlo como no iniciado.
  optional: { id: COURSE_STATUS_PENDING, name: 'Opcional' },
};
